import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { FiMenu, FiX } from 'react-icons/fi'; // Import icons
import './Header.css';

const Header = () => {
    const { user, logout } = useContext(UserContext);
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false); // State for menu toggle

    // Function to close the dropdown menu when resizing to a larger screen
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setMenuOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <header className="menu-bar">
            {/* Full-screen navigation */}
            <div className="fullscreen-menu">
                <Link to="/" className="fullscreen-menu-link">
                    <img
                        src={require('../../pages/HomePage/vla_header_logo.png')}
                        alt="Home"
                        style={{ height: '20px', objectFit: 'contain' }}
                    />
                </Link>
                <Link to="/" className="fullscreen-menu-link">
                    <img
                        src={require('../../pages/HomePage/home_icon_small.jpg')}
                        alt="Home"
                        style={{ height: '20px', objectFit: 'contain' }}
                    />
                </Link>
                <Link to="/submitauthentication" className="fullscreen-menu-link">Submit Authentication</Link>
                <Link to="/certificatelookup" className="fullscreen-menu-link">Certificate Lookup</Link>
            </div>

            <div className="fullscreen-right-menu">
                {user ? (
                    <>
                        <Link to="/profilepage" className="fullscreen-menu-link">My Profile</Link>
                        <span className="fullscreen-menu-link fullscreen-logout-link" onClick={handleLogout}>Logout</span>
                    </>
                ) : (
                    <>
                        <Link to="/signup" className="fullscreen-menu-link">Create Account</Link>
                        <Link to="/login" className="fullscreen-menu-link">Log In</Link>
                    </>
                )}
            </div>

            {/* Hamburger Menu for Mobile */}
            <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
            </div>

            {/* Mobile Dropdown Menu */}
            <nav className={`mobile-menu-container ${menuOpen ? 'active' : ''}`}>
                <Link to="/" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>Home</Link>
                <Link to="/submitauthentication" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>Submit Authentication</Link>
                <Link to="/certificatelookup" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>Certificate Lookup</Link>
                {user ? (
                    <>
                        <Link to="/profilepage" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>My Profile</Link>
                        <span className="mobile-menu-link" onClick={() => { handleLogout(); setMenuOpen(false); }}>Logout</span>
                    </>
                ) : (
                    <>
                        <Link to="/signup" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>Create Account</Link>
                        <Link to="/login" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>Log In</Link>
                    </>
                )}
            </nav>
        </header>
    );
};

export default Header;
